export const BACKEND_API_BASE_URL =
  import.meta.env.VITE_BACKEND_API_BASE_URL || 'http://localhost:8080';

// Journey Path Constants
export const V3_JOURNEY_PATH = 'get-started-v3';
export const V4_JOURNEY_PATH = 'get-started-v4';
export const V5_JOURNEY_PATH = 'get-started-v5';
export const V6_JOURNEY_PATH = 'get-started-v6';
export const V7_JOURNEY_PATH = 'get-started-v7';
export const V9_JOURNEY_PATH = 'get-started-v9';

export const SCREENS_EXCLUDED_FOR_CLAIM_PAYLOAD = [
  // standalone pages
  'resume',
  'sign-redo',
  'questions-resume',
  // ancillary pages
  'complaints',
  'cookies-policy',
  'faqs',
  'frequently-asked-questions',
  'privacy-policy',
  'terms-and-conditions',
  // and any page that is already added to the screens_completed list (check from backend)
];

export const FAIR_DATE_FORMAT: string = 'DD/MM/YYYY';
export const ZOHO_DATE_FORMAT: string = 'YYYY-MM-DD';

export const DUMMY_QUESIONS_RESPONSE = {
  data: {
    success: true,
    message: 'data retrieve',
    responseObject: {
      transactionId: 'd49ee5f2-7110-4764-9c95-e66142a9fe11',
      status: 'true',
      applicationId: 'xst01',
      consumerId: 'xst01_sts1',
      correlationId: '1a9abe43-cfdc-466b-9960-463a94584645',
      referenceId: '71A9-BCB2-DC0A',
      tenantId: 'xst01',
      results: [
        {
          authenticationId: 'ade6a6dd-cd9a-4022-8a3b-86d019ff5edb',
          questionnaire: {
            questionnaireId: 1,
            questionGroups: [
              {
                questionGroup: 'PERSONAL_LOAN',
                questionHeader:
                  'Your Equifax credit file indicates that you may have a loan or fixed term account opened on or around May 2024 and updated in January 2025.',
                appliesToQuestionId: [1],
              },
              {
                questionGroup: 'SECOND_MORTGAGE',
                questionHeader:
                  'Your Equifax credit file indicates that you may have had a mortgage account opened on or around June 2018 and updated in August 2020.',
                appliesToQuestionId: [2, 3],
              },
            ],
            questions: [
              {
                questionId: 1,
                questionText: 'Who gave you the finance?',
                choiceType: {
                  type: 'SINGLE_CHOICE',
                },
                choices: [
                  {
                    choiceId: 1,
                    choiceText: 'MyJar',
                  },
                  {
                    choiceId: 2,
                    choiceText: 'Ikano Financial Services Ltd',
                  },
                  {
                    choiceId: 3,
                    choiceText: 'O2',
                  },
                  {
                    choiceId: 4,
                    choiceText: 'HSBC',
                  },
                  {
                    choiceId: 5,
                    choiceText: 'None of the Above',
                  },
                ],
              },
              {
                questionId: 2,
                questionText: 'Who is your mortgage provider?',
                choiceType: {
                  type: 'SINGLE_CHOICE',
                },
                choices: [
                  { choiceId: 1, choiceText: 'Santander' },
                  { choiceId: 2, choiceText: 'TSB Bank' },
                  { choiceId: 3, choiceText: 'Bank of Ireland' },
                  { choiceId: 4, choiceText: 'Woolwich / Barclays' },
                  { choiceId: 5, choiceText: 'None of the Above' },
                ],
              },
              {
                questionId: 3,
                questionText: 'What is your current repayment amount?',
                choiceType: { type: 'SINGLE_CHOICE' },
                choices: [
                  { choiceId: 1, choiceText: '£600 to £649' },
                  { choiceId: 2, choiceText: '£650 to £699' },
                  { choiceId: 3, choiceText: '£700 to £749' },
                  { choiceId: 4, choiceText: '£750 to £799' },
                  { choiceId: 5, choiceText: 'None of the Above' },
                ],
              },
            ],
          },
        },
      ],
      configId: 'xst01',
      productId: 'IdentityAssurance',
      assessment: [
        { key: 'AMLAssessment', value: 'PASS' },
        { key: 'decision', value: 'CHALLENGE' },
        { key: 'AMLN&A', value: '9' },
        { key: 'AMLPersonal', value: '1' },
        { key: 'AMLAlerts', value: '0' },
      ],
      originalTransactionId: 'd49ee5f2-7110-4764-9c95-e66142a9fe11',
    },
  },
};

export const DISCORD_BOTS = {
  USER_LANDED:
    'https://discord.com/api/webhooks/1418553047499407380/K3-oZ5M8z39GFVyvGA3i6lJfV2oQj0sjgyMcdT_OJa8AKXD5kUdrTicvN8-zRhw5WzGm',
  GET_STATED:
    'https://discord.com/api/webhooks/1293049595986706433/CVrpezfybmpnvFaQbxBmrcB0mzVnEUl5274XrYMIW6MpwSOMEZHitFi-i4zbJ1La_qkp',
  BASIC_INFO:
    'https://discord.com/api/webhooks/1293067094061219910/CHMb6Qt3Y7lqBHUb3BYDVJUYt2re_H054ua9-fvOqDm1XJl2F5OhmrB06IQzWQjP3-2t',
  CONTACT_INFO:
    'https://discord.com/api/webhooks/1293067234612346900/3nqeR5q0rv1rYuJUaH-mGLeXptHbkgO2FhQjtpDHAlOlJAIzbeFPAcMUzueLRhyHWl4l',
  SIGNATURE_COLLECTED:
    'https://discord.com/api/webhooks/1293067342107906118/XbnOvO1lNpp9ZqmnpOAJ-UgNK-IsH6EyanLqiQVwtUYi9QF4M3Lbt_kemXK139twpbH3',
  IDV_SELECTION:
    'https://discord.com/api/webhooks/1293107033897308263/WX_-EaR4I3nW58AzFwbSVgFaIJfE68FKKeA_U4S_XNMdiGhgH4mjSfaW7ezOfZ3oeW0_',
  IDV_OB:
    'https://discord.com/api/webhooks/1293067487268835419/9-of7_GDBtddx7LhV4jiqXAh5s8XQronqFhCxb9x-ZTqgJ_WtdmS9FU7PyYWHSi7hrbr',
  IDV_SELFIE:
    'https://discord.com/api/webhooks/1293067599378255904/dneRdNfBtgroqgCuXsSIWClpRrB1H1a5EhewDxczMsIHpoRqz0jANaiTyyK7XWYh0YV1',
  IDV_STARTED:
    'https://discord.com/api/webhooks/1297863945172025425/CHyvsur460Z7Vs8iPLNrbjbjJrezfWbIdrGWcx97sBIXRL_tTbkvCmCH4oZ6zrJnOKmx',
  KOUNT_COLLECTED:
    'https://discord.com/api/webhooks/1293068101620994121/bvdvok4vPQ92aYbDbdvj4fc-QpXWb9_tNtXSfoXZ0hPg85vvX2RS0jAAeXvn5vTipq7N',
  CREDIT_CHECK:
    'https://discord.com/api/webhooks/1293067805142552668/kjS5CKkmh5SGNul6H4p8sgkEDQmpdOppqdH2jNkcbAkBeufBhFpbwJrVWoQnTvb5feuC',
  CREDIT_CHECK_POST_IDV:
    'https://discord.com/api/webhooks/1308038459474055240/U_SYbu0JLujtwK0sOi1AbG4hJUedYdB5xmCR2btCd1ShosL9a0wbtMuLH3P1tCbvUBMe',
  CLAIM_SUBMITTED:
    'https://discord.com/api/webhooks/1293068013980880916/zF4LuZ-72jlpNC1YrH8MJC6M5bff0JwRUp38cLcyiCwg2JCbIdsuSF55Fe-FXKvS7jj6',
  EMAIL_TRIGGER:
    'https://discord.com/api/webhooks/1293068324963487745/FSrQWAUio-PgKrlnkSO_rwXcCHm2y3395nNNJzmiZiOpgREZkjr4wSa_opF4GFscQJLW',
  SMS_TRIGGER:
    'https://discord.com/api/webhooks/1293068470543716352/nHrPRBR_LvvGbw7R6C-iWNKtW7MKoj58LgUYqDaJYTZo0AYN-x8Vv15h0p6Yrg5leUoq',
  TEST_BOT:
    'https://discord.com/api/webhooks/1293146855945011325/jEeYKlb1I7r1WOOcNZQoyTA8CHVdKJJA9bCb57gPXAM7U_5RtlkS7qdAn6KibaAwcqky',
  BOT_ALERT:
    'https://discord.com/api/webhooks/1293805845301297224/kqOdsTXuqQOZRg7tRO6WX_5qr7AhNAZzlyleaKFvT8mUtTUWa0TFsveFbON7Q6CyI7WS',
  LUMINATE_BOT:
    'https://discord.com/api/webhooks/1294342342932959242/Hu4CNq7ucP8oCDsokM6_Uu-9uO5SVVg_E_RLVVzHEdsjckc29MOsGhCZhF-V3xQpOHRy',
  LUMINATE_QUESTIONS_PULLED_BOT:
    'https://discord.com/api/webhooks/1396963466862137385/zKqr8-WikeBd6IEoFEyRZnF0XAKUH5hACzfs69yBfeVk_r2_pqCCjVLqIwc3epO7Pvq4',
  HIGH_QUALITY_CLAIMS:
    'https://discord.com/api/webhooks/1296434175020109886/9cDTw_7D91VFmYkfkr3ywA9aqiOrEMl7ZfB4nef83ZUOqw7nLzsxAEcdGQy-F4j6gh-E',
  RECLAIMS_HIGH_QUALITY_CLAIMS:
    'https://discord.com/api/webhooks/1303413170890608740/x4IZP7CyxPwr04IWCGiHU19p7yZM7my2WovuxOjKzCpOsJfSAMKgpFfR5eM5QiouVlyp',
  FB_CREDIT_REPORT:
    'https://discord.com/api/webhooks/1296895582756929680/vUMD9CTXF2Me1tmu5G8vBDPGa_8q1T-_c8YRwDwshhmtiw_Gbaa1v8Z1pLxDCrHDq0Dp',
  CLAIM_FAILURE_BOT:
    'https://discord.com/api/webhooks/1297945040009560136/3iW9nKImHxcRHKv9zZ02URj8URFHxKoPihPTbDHMfL5JLNaVSUuTePVL3ZImZ5lqhVMi',
  CREDIT_CHECK_DETAILS:
    'https://discord.com/api/webhooks/1297998022592040970/HodrAwwp2bBfg_90qtxLnVAZ-v5JlAjWJWz8pa4tPXBlUBL0xMUt4hTYcn-7ys2_YmT3',
  HQ_OUTBRAIN_BOT:
    'https://discord.com/api/webhooks/1301209457493147728/oxoRFR57MmSs6veTFIwToCK2jnCLZifr7HBw682i5d239w1W7oN_fhWZbsr41oc1BEDq',
  SECURED_LOANS_BOT:
    'https://discord.com/api/webhooks/1301213695111598170/KN9775hIOkykqR-NSTkJNJQcGRY6OWWCglVncxiomgpapYLnQAylQ4Hv39yrMSIfyeXB',
  UN_SECURED_LOANS_BOT:
    'https://discord.com/api/webhooks/1301214465819279441/2ThRmaUeHMdFU77xLEgI108jHRZX526X4a2pZeY5U1vYeyimjVVlhYs-R10VRGb2nvxH',
  FIXED_TERMS_BOT:
    'https://discord.com/api/webhooks/1301214628637966469/y186QRx5-fQhgGaykzlBMNiaHrqW7p16nr9DUQhq_3Uoyl-X1lC3Hq7KIi0CDpqSq4lu',
  RENTAL_AGREEMENT_BOT:
    'https://discord.com/api/webhooks/1313067344657911899/yS5HMlOLfs_JsVfFe-4J0QE1MVT76DVJ-MwGg1DR54YrwTnt2MZGY-JlP8Y8vFJjIq6j',
  DUPLICATE_LOANS:
    'https://discord.com/api/webhooks/1301500088048160840/O6PsPeVOL1rTUQkRHEFyN9h1NBtI4FfgICRtuVG_h-zLJTUY_tWDaA0iplSVfzMqK9lO',
  RETURNING_USER:
    'https://discord.com/api/webhooks/1302877140919779358/74MBznSqr1-8SrvCe-jbNfMpbk-Et8KmrjpbqAJWi9rmCWSzAaTeYBq5EgvsbZISuOrB',
  DIGITAL_TRUST:
    'https://discord.com/api/webhooks/1308872764396011623/K3aYdyI0z0FX0iUi0W58xLJTrz0Iu1P9iGujrPTZVL5E3fecXEZRVNe-sf4udGGNEWuQ',
  VALID8_CREDIT_PULL:
    'https://discord.com/api/webhooks/1311981962721759286/4lM1xZmmR6qv5l6x5nL4ce9rtpuCi3zndsuvfVSpgmGjwGxh2eI8IKEgRkioVo9fDrnW',
  DUPLICATE_CLAIM:
    'https://discord.com/api/webhooks/1312862184715321496/Sm06z9Ko7Z98w5e_hxxL6iCT6JaQp1tERIA37pIzhICcfGuZjDNVbxzyNdAavpfSZplZ',
  FEEDBACK:
    'https://discord.com/api/webhooks/1314230820290170890/j2DEwj6e92nuBDCyz37vYv78IEXWCTh82TEsYogO0mz7ACbp66RxPhxmZM21A6kMKuHH',
  MANUALLY_SELECTED_LENDERS:
    'https://discord.com/api/webhooks/1313870485666140251/jeP2nMxQpBOS4UV1tAwi-JQj0s7aDevAVZVS2AgJkOqOLRE-ehWc_a7RkCisRxNF4mlE',
  ONFIDO_EVENTS:
    'https://discord.com/api/webhooks/1321581628983742484/1jDUMyRUL6DTfWypRJQ55HDqh_wU2VQqz_ZUDFmCgnVrFKHRq6VUAilNRRRZYYZdSFFy',
  UNSIGNED_BOTS:
    'https://discord.com/api/webhooks/1348330364845686945/IGsP0O56SV4CUI7gcDEVoqCD8w-F_UdN5fZu0KbMUYvPJQhP_gVo68fdVd4ihgMEok_k',
  PASTE_BOT:
    'https://discord.com/api/webhooks/1403328307688374273/cMLZajlZs3rdg8SMYt5MGFrSXrrMyCHavBXrJACZSTmh34byktsbg2W8N-6T3U0xKGAp',
  ZOHO_USER_CREATED:
    'https://discord.com/api/webhooks/1417865896772374661/NtxbLHNN9JP0J7BzX7fadgJp31N7pAqORKsf49sVWw9FpaPv4NiIx76mHQYjty4WjTqW',
  MANUAL_IDV_STARTED:
    'https://discord.com/api/webhooks/1413317779746193439/nOvUUYrDsGpuoaASfQXAuW0eBmrL2-o5eMT6rTpvZTkJ4SLlEwMGe8eMkhTRyUjdheGF',
  MANUAL_IDV_DOCUEMNT_UPLOAD:
    'https://discord.com/api/webhooks/1413328637444231228/X8JqpnRNh-Rpdf1fKvRPjaywI-38g8lzx0P09AEDAAQ5X-4WreJc0GPj9ISSiitRj-Gb',
  MANUAL_IDV_SELFIE_UPLOAD:
    'https://discord.com/api/webhooks/1413328916675821578/3z1fZ-YvgbX9b8puQ_4g8jordmhcnZuvj5DqyaDm42Xc_qCn2hPjAAp_O0DB5CDaCKel',
};

export const TiktokPixel_EVENTS = {
  postcode: 'Search',
  car_financed_0721: 'ViewContent',
  basic_info: 'basic_info',
  sign_claim: 'Subscribe',
  lead_without_idv: 'SubmitForm',
  Lead: 'CompleteRegistration',
  Contact: 'Contact',
  contact_info: 'contact_info',
  disclaimer: 'disclaimer',
  credit_check_failed: 'credit_check_failed',
  credit_report: 'credit_report',
  lender: 'lender',
  id_selfie_upload: 'id_selfie_upload',
  luminate: 'luminate',
  dealer_comm_disclosed: 'dealer_comm_disclosed',
};

export const SUB2_EVENTS = {
  // [DISCORD_BOTS.GET_STATED]: 'dealer_comm_disclosed',
  POSTCODE: 'postcode',
  BASIC_INFO: 'basic_info',
  CONTACT_INFO: 'contact_info',
  CL_CONTACT_INFO: 'CL_contact_info',
  Lead: 'lead_contact',
  // lead_with_credit: 'lead_with_credit',
  lead_with_credit: 'Lead',
  cl_lead_with_credit: 'CL_Lead',
  CompleteRegistration: 'CompleteRegistration',
  lead_with_credit_new_pixel: 'Lead_NEW_PIXEL',
  car_financed_0721: 'car_financed_0721',
  // [DISCORD_BOTS.BASIC_INFO]: "basic_info",
  // [DISCORD_BOTS.CONTACT_INFO]: "contact_info",
  signed_up: 'signed_up',
  cl_signed_up: 'CL_signed_up',
  claims_found: 'claims_found',
  cl_claims_found: 'CL_claims_found',
  DISCLAIMER: 'disclaimer',
  // [DISCORD_BOTS.SIGNATURE_COLLECTED]: "sign_claim",
  CREDIT_RE_CHECK: 'credit_check_failed',
  credit_report: 'credit_report',
  LENDER: 'lender',
  SELFIE_UPLOAD: 'id_selfie_upload',
  // [DISCORD_BOTS.LUMINATE_BOT]: 'luminate',
  luminate: 'luminate',
  dealer_comm_disclosed: 'dealer_comm_disclosed',
  // LEAD_WITH_IDV: 'lead_with_idv',
  LEAD_WITH_IDV: 'Contact',
  HIGH_VALUE_LEAD: 'HighValueLead',
  IDV_COMPLETED: 'IDVCompleted',
  lead_social: 'Lead',
  noAgreementFound: 'NoAgreementFound',
  duplicateBlocked: 'DuplicateBlocked',
  submitApplication: 'SubmitApplication',
  viewContent: 'ViewContent',
  InitiateCheckout: 'InitiateCheckout',
};

export const DATALAYER_EVENTS = {
  Lead: 'lead_social',
  LeadWithCredit: 'lead_with_credit',
  CL_Lead: 'CL_lead_with_credit',
  Lead_NEW_PIXEL: 'lead_with_credit_new_pixel',
  Contact: 'lead_with_idv',
  IDVCompleted: 'lead_with_idv_complete',
  NoAgreementFound: 'noAgreementFound',
  DuplicateBlocked: 'duplicateBlocked',
  SubmitApplication: 'submitApplication',
  ViewContent: 'viewContent',
};

export const TIGHT_CAMPAIGNS = [
  '23848724525540792', // 09.08.25_Images_CBO – Signed Up
  '23849071193530792', // 14.08.25_Images_ABO – Signed Up – CostCap
  '23849071162830792', // 09.08.25_Images_CBO – Signed Up – Cost Cap
];

export const COST_CAP_TEST_CAMPAIGNS = [
  '23849071162830792', // 09.08.25_Images_CBO – Signed Up – Cost Cap
  '23849071116560792', // 09.08.25_Images_CBO – Signed Up – Test Audience – Cost Cap
];

export const CCLoaderMessages = {
  'loading.security.title': 'Secure check in progress…',
  'loading.security.sub': 'This won’t affect your credit score',
  'loading.progress.title': 'Almost there — fetching your results now.',
  'loading.progress.sub': 'Please keep this window open',
  'loading.slow': 'Still working… this can take a little longer at busy times.',
  'loading.retry': 'Retry lookup',
};

// ============================================================================
// TEST CONFIGURATION VARIABLES FOR @fair.inc USERS
// ============================================================================
// Select which dummy flow you want to test ('experian' | 'equifax')
// If you set it to 'equifax', Experian will intentionally return no agreements
// so that the flow naturally proceeds to the Equifax screen.
export const TEST_FLOW: 'experian' | 'equifax' = 'experian';

// Select whether the chosen dummy flow should return agreements or not
export const TEST_RETURN_AGREEMENTS: boolean = false;

// ============================================================================
// SCREEN VISIBILITY CONFIGURATION FLAGS
// ============================================================================
export const checkingEligibilityScreen: boolean = false;
export const settingUpCaseScreen: boolean = false;
